<template>
  <vue-final-modal
    v-model="showLoginModal"
    name="loginModal"
    classes="modal-container"
    content-class="modal-content"
    :click-to-close="false"
    :lock-scroll="false"
    v-if="getLoginModalTrans">
    <div class="modal-data" v-if="login">
      <h1>{{getLoginModalTrans.login_title}}</h1>
      <p class="modal-message">{{getLoginModalTrans.login_p}}</p>
      <div class="form-modal">
        <BaseInput
          v-model="loginData.email"
          :required="true"
          :label="getLoginModalTrans.email_label"
          :error="isValidEmailLogin"
        />
        <div class="apiAlert" v-if="apiError">
          <p>{{ apiErrorMessage }}</p>
        </div>
        <button class="btn-form" @click="loginAPI" :disabled="isValidEmailLogin !== true">{{getLoginModalTrans.recieve_code}}</button>
      </div>
      <button class="btn-link" @click="wantRegister">{{getLoginModalTrans.register_here}}</button>
    </div>
    <div class="modal-data" v-if="register">
      <h1>{{getLoginModalTrans.register_title}}</h1>
      <p class="modal-message">{{getLoginModalTrans.vote_message}}</p>
      <div class="form-modal">
        <BaseInput
          v-model="registerData.name"
          :required="true"
          :label="getLoginModalTrans.name_label"
          :error="isValidName"
        />
        <BaseInput
          v-model="registerData.surname"
          :required="true"
          :label="getLoginModalTrans.surname_label"
          :error="isValidSurname"
        />
        <BaseInput
          v-model="registerData.email"
          :required="true"
          :label="getLoginModalTrans.email_label"
          :error="isValidEmailRegister"
        />
        <CheckLegal />
        <div class="apiAlert" v-if="apiError">
          <p>{{ apiErrorMessage }}</p>
        </div>
        <button class="btn-form" @click="registerAPI" :disabled="!isValidRegister">{{getLoginModalTrans.register_btn}}</button>
      </div>
      <button class="btn-link" @click="wantLogin">{{getLoginModalTrans.login_here}}</button>
    </div>
    <div class="moda-data" v-if="verifyAccount">
      <h1>{{getLoginModalTrans.verify_account_title}}</h1>
      <BaseInput
        v-model="verifyAccountData.code"
        :required="true"
        :label="getLoginModalTrans.code"
        :error="isValidCode"
        class="text-center"
      />
      <button class="btn-form" @click="verifyAccountAPI" :disabled="!isValidCode">{{getLoginModalTrans.verify_account_btn}}</button>
    </div>
    <div class="modal-data" v-if="code">
      <h1>{{getLoginModalTrans.auth_title}}</h1>
      <p class="modal-message">{{getLoginModalTrans.auth_p}}</p>
      <BaseInput
        v-model="verifyCodeData.code"
        :required="true"
        :label="getLoginModalTrans.code"
        :error="isValidCodeSession"
        class="text-center"
      />
      <button class="btn-form" @click="verifyCodeFromAPI" :disabled="!isValidCodeSession">{{getLoginModalTrans.verify_account_btn}}</button>
    </div>
    <button class="btn-cookies-black" @click="showLoginModal = !showLoginModal">{{getLoginModalTrans.cancel_btn}}</button>
  </vue-final-modal>
</template>

<script>
import BaseInput from '@/components/BaseInput.vue'
import CheckLegal from '@/components/CheckLegal.vue'
import { mapGetters, mapMutations, mapState } from 'vuex'
import ApiService from '@/services/ApiService'
import LocalStorageService from '@/services/LocalStorageService'

export default {
  name: 'LoginModal',
  data () {
    return {
      showLoginModal: false,
      register: false,
      verifyAccount: false,
      login: true,
      code: false,
      loginData: {
        email: null
      },
      registerData: {
        name: null,
        surname: null,
        email: null
      },
      verifyAccountData: {
        email: null,
        code: null
      },
      verifyCodeData: {
        code: null
      },
      apiError: false,
      apiErrorMessage: ''
    }
  },
  components: {
    BaseInput,
    CheckLegal
  },
  computed: {
    ...mapState(['idContest', 'email', 'token', 'acceptLegal', 'codeLang']),
    ...mapGetters(['getPrimary', 'getLoginModalTrans']),
    isValidName () {
      if (this.registerData.name !== null && this.registerData.name.trim().length > 1) {
        return true
      }
      return ''
    },
    isValidSurname () {
      if (this.registerData.surname !== null && this.registerData.surname.trim().length > 1) {
        return true
      }
      return ''
    },
    isValidCode () {
      if (this.verifyAccountData.code !== null && this.verifyAccountData.code.trim().length > 5) {
        return true
      }
      return ''
    },
    isValidCodeSession () {
      if (this.verifyCodeData.code !== null && this.verifyCodeData.code.trim().length > 5) {
        return true
      }
      return ''
    },
    isValidEmailLogin () {
      if (this.loginData.email !== null) {
        const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if (!regex.test(String(this.loginData.email).toLowerCase())) {
          return this.getLoginModalTrans.invalid_email
        }
        return true
      } else return ''
    },
    isValidEmailRegister () {
      if (this.registerData.email !== null) {
        const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if (!regex.test(String(this.registerData.email).toLowerCase())) {
          return this.getLoginModalTrans.invalid_email
        }
        return true
      } else return ''
    },
    isValidRegister () {
      return this.isValidName && this.isValidSurname && (this.isValidEmailRegister === true) && this.acceptLegal
    }
  },
  methods: {
    ...mapMutations(['setEmail', 'setToken', 'changeLoading']),
    wantRegister () {
      this.register = true
      this.verifyAccount = false
      this.login = false
      this.code = false
      this.apiError = false
    },
    wantVerifyAccount () {
      this.register = false
      this.verifyAccount = true
      this.login = false
      this.code = false
      this.apiError = false
    },
    wantLogin () {
      this.register = false
      this.verifyAccount = false
      this.login = true
      this.code = false
      this.apiError = false
    },
    wantCode () {
      this.register = false
      this.verifyAccount = false
      this.login = false
      this.code = true
      this.apiError = false
    },
    contestUnavailable (data) {
      this.apiError = false
      this.$vfm.hide('loginModal')
      this.$router.push('/')
      this.changeLoading(false)
    },
    errorAPI (error) {
      error = ''
      this.apiError = true
      this.apiErrorMessage = this.getLoginModalTrans.api_error_message_send
      this.changeLoading(false)
    },
    async registerAPI () {
      this.apiError = false
      this.changeLoading(true)
      const dataToSend = {
        id: this.idContest,
        email: this.registerData.email,
        name: this.registerData.name,
        surname: this.registerData.surname,
        lang_code: this.codeLang
      }
      try {
        const response = await ApiService.registerAPI(dataToSend)
        const responseData = response.data.data
        if (response.data.code === 200) {
          this.$swal({
            icon: 'success',
            title: this.getLoginModalTrans.register_success_title,
            html: `
              <p>${this.getLoginModalTrans.register_success_p1}</p>
              <p>${this.getLoginModalTrans.register_success_p2}</p>
            `,
            confirmButtonColor: this.getPrimary,
            confirmButtonText: '<i class="fa fa-check"></i> Ok'
          })
          LocalStorageService.setStringify(
            'session',
            {
              userEmail: this.registerData.email
            }
          )
          this.setEmail(this.registerData.email)
          this.wantVerifyAccount()
          this.changeLoading(false)
        } else if (response.data.code === 409) {
          this.apiError = true
          this.apiErrorMessage = this.getLoginModalTrans.api_error_message_exists
          this.changeLoading(false)
        } else if (response.data.code === 404) {
          this.contestUnavailable(responseData)
        } else {
          this.errorAPI(responseData)
        }
      } catch (error) {
        this.errorAPI(error)
      }
    /* eslint-disable comma-dangle */
    },
    async verifyAccountAPI () {
      this.apiError = false
      this.changeLoading(true)
      const dataToSend = {
        id: this.idContest,
        email: this.email,
        code: this.verifyAccountData.code,
      }
      try {
        const response = await ApiService.verifyAccountAPI(dataToSend)
        const responseData = response.data.data
        if (response.data.code === 200) {
          this.$swal({
            icon: 'success',
            title: this.getLoginModalTrans.verified_account_title,
            html: `
              <p>${this.getLoginModalTrans.verified_account_p1}</p>
              <p>${this.getLoginModalTrans.verified_account_p2}</p>
            `,
            confirmButtonColor: this.getPrimary,
            confirmButtonText: '<i class="fa fa-check"></i> Ok'
          })
          this.setToken(responseData.token)
          this.setEmail(dataToSend.email)
          LocalStorageService.setStringify(
            'session',
            {
              userEmail: dataToSend.email,
              token: responseData.token
            }
          )
          this.$vfm.hide('loginModal')
          this.wantLogin()
          this.changeLoading(false)
        } else if (response.data.code === 404) {
          this.contestUnavailable(responseData)
        } else {
          this.errorAPI(responseData)
        }
      } catch (error) {
        this.errorAPI(error)
      }
    },
    async loginAPI () {
      this.apiError = false
      this.changeLoading(true)
      const dataToSend = {
        id: this.idContest,
        email: this.loginData.email,
        lang_code: this.codeLang
      }
      try {
        const response = await ApiService.loginAPI(dataToSend)
        const responseData = response.data.data
        if (response.data.code === 200) {
          this.$swal({
            icon: 'success',
            title: this.getLoginModalTrans.code_sended_title,
            html: `
              <p>${this.getLoginModalTrans.code_sended_p}</p>
            `,
            confirmButtonColor: this.getPrimary,
            confirmButtonText: '<i class="fa fa-check"></i> Ok'
          })
          LocalStorageService.setStringify(
            'session',
            {
              userEmail: this.loginData.email
            }
          )
          this.apiError = false
          this.wantCode()
          this.changeLoading(false)
        } else if (response.data.code === 404) {
          this.contestUnavailable(responseData)
        } else if (response.data.code === 401) {
          this.apiError = true
          this.apiErrorMessage = `${this.getLoginModalTrans.api_error_email_not_exists}: ${this.loginData.email}.`
          this.changeLoading(false)
        } else {
          this.errorAPI(responseData)
        }
      } catch (error) {
        this.errorAPI(error)
      }
    },
    async verifyCodeFromAPI () {
      this.apiError = false
      this.changeLoading(true)
      const dataToSend = {
        id: this.idContest,
        email: LocalStorageService.getParsed('session').userEmail,
        code: this.verifyCodeData.code,
      }
      try {
        const response = await ApiService.verifyCodeAPI(dataToSend)
        const responseData = response.data.data
        if (response.data.code === 200) {
          this.$swal({
            icon: 'success',
            title: this.getLoginModalTrans.correct_login_title,
            html: `
              <p>${this.getLoginModalTrans.correct_login_p1}</p>
              <p>${this.getLoginModalTrans.correct_login_p2}</p>
            `,
            confirmButtonColor: this.getPrimary,
            confirmButtonText: '<i class="fa fa-check"></i> Ok'
          })
          this.apiError = false
          this.setToken(responseData.token)
          this.setEmail(dataToSend.email)
          LocalStorageService.setStringify(
            'session',
            {
              userEmail: dataToSend.email,
              token: responseData.token
            }
          )
          this.$vfm.hide('loginModal')
          this.wantLogin()
          this.changeLoading(false)
        } else if (response.data.code === 404) {
          this.contestUnavailable(responseData)
        } else {
          this.errorAPI(responseData)
        }
      } catch (error) {
        this.errorAPI(error)
      }
    }
  },
  created () {
    if (this.email !== null) {
      this.loginData.email = this.email
    }
  }
}
</script>

<style scoped>
:deep(.modal-container) {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  height: 100%;
  margin-top: auto;
  margin-bottom: auto;
  overflow-y: auto;
  padding: 1rem;
  top: auto;
  left: auto;
  right: auto;
  bottom: auto;
  width: 100%;
}
:deep(.modal-content) {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  border-radius: 0.75rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  margin-top: auto;
  margin-bottom: auto;
  padding: 2rem;
  width: 375px;
}
:deep(.modal-data) {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 100%;
}
:deep(.modal-content h1) {
  font-weight: 700;
  font-size: 1.5rem;
  line-height: 2rem;
  margin-bottom: 1rem;
  text-align: center;
  color: var(--primary);
}
:deep(.modal-message) {
  text-align: left;
}
:deep(.form-modal) {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: start;
  -ms-flex-align: start;
  -webkit-align-items: flex-start;
  align-items: flex-start;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  -webkit-justify-content: flex-start;
  justify-content: flex-start;
  width: 100%;
}
:deep(.btn-form) {
  background-color: var(--primary);
  border-radius: 0.25rem;
  margin-left: auto;
  margin-right: auto;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  width: 100%;
}
:deep(.btn-form):hover {
  opacity: 0.9;
}
:deep(.btn-form):focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
:deep(.btn-form):focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
:deep(.btn-form:disabled) {
  cursor: not-allowed;
  opacity: 0.6;
}
:deep(.btn-link) {
  cursor: pointer;
  margin-top: 1rem;
  margin-bottom: 1rem;
  margin-left: auto;
  margin-right: auto;
  color: var(--primary);
  -webkit-text-decoration-line: underline;
  text-decoration-line: underline;
}
:deep(.btn-link):focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
:deep(.btn-link):focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
:deep(.btn-cookies-black):hover {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
:deep(.btn-cookies-black) {
  border-radius: 0.25rem;
  border-width: 2px;
  margin-left: auto;
  margin-right: auto;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  width: 100%;
}
:deep(.btn-cookies-black):focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
:deep(.btn-cookies-black):focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
:deep(.apiAlert) {
  --tw-bg-opacity: 1;
  background-color: rgba(216, 38, 46, var(--tw-bg-opacity));
  --tw-bg-opacity: 0.1;
  --tw-border-opacity: 1;
  border-color: rgba(216, 38, 46, var(--tw-border-opacity));
  border-radius: 0.5rem;
  border-width: 1px;
  margin-top: 1rem;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
</style>
